import React, { FC, useEffect } from 'react';

import { Categories } from '@ariksa/inventory-core/api';
import { useDispatch } from 'react-redux';

import { Card } from 'components/DataDisplay';
import { actions } from 'containers/Setup/DataConfiguration/slice';
import { actions as sharedStateActions } from 'containers/SharedState/slice';
import { useSearchParams } from 'hooks/useSearchParams';

import { DataClassifierForm } from './DataClassifierForm';

interface Props {
  classifier: Record<string, any>;
  onClose: () => void;
}

export const EditDataClassifier: FC<Props> = props => {
  const dispatch = useDispatch();
  const { viewBy: selectedTab = 'types' } = useSearchParams<{
    viewBy: string;
    uuid: string;
  }>();
  const { classifier, onClose } = props;

  useEffect(() => {
    selectedTab === 'types' && dispatch(actions.getSensitivityInfo({}));
  }, [selectedTab, dispatch]);

  useEffect(() => {
    selectedTab === 'types' &&
      dispatch(
        sharedStateActions.getLabels({ q: { category: Categories.Data } }),
      );
  }, [dispatch, selectedTab]);

  return (
    <Card
      contentComponent={
        <DataClassifierForm
          actionType="Update"
          classifier={classifier}
          onClose={onClose}
          selectedTab={selectedTab}
        />
      }
    />
  );
};
